import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import BuyCisPage from './BuyCisPage';
import BuyRussiaPage from './BuyRussiaPage';
import CreamPage from './CreamPage';
import GelPage from './GelPage';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider, useLanguage } from './i18n';

function Root() {
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const { language, messages } = useLanguage();

  useEffect(() => {
    const [title, description] = messages.seo[path] || messages.seo['/'];
    const pageUrl = window.location.href;
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
    document.querySelector('meta[property="og:locale"]')?.setAttribute(
      'content',
      language === 'en' ? 'en_US' : 'ru_RU',
    );
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', title);
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', description);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', pageUrl);
    document.querySelector('meta[name="twitter:title"]')?.setAttribute('content', title);
    document.querySelector('meta[name="twitter:description"]')?.setAttribute('content', description);
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', pageUrl);
  }, [language, messages, path]);

  if (path === '/gel') {
    return <GelPage />;
  }

  if (path === '/cream') {
    return <CreamPage />;
  }

  if (path === '/buy/russia') {
    return <BuyRussiaPage />;
  }

  if (path === '/buy/cis') {
    return <BuyCisPage />;
  }

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <Root />
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
